import { render } from "./eduResearchMenu.vue?vue&type=template&id=4408d559&scoped=true"
import script from "./eduResearchMenu.vue?vue&type=script&lang=js"
export * from "./eduResearchMenu.vue?vue&type=script&lang=js"

import "./eduResearchMenu.vue?vue&type=style&index=0&id=4408d559&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4408d559"]])

export default __exports__